<form [formGroup]="form" autocomplete="off" class="form-horizontal">
    <div class="form-row">
        <label
                class="col-sm-4 col-form-label" for="taetigkeitsart{{index}}"
                title="{{ 'COMMON_UI.FRAGEBOGEN.TAETIGKEITSART.LABEL' | translate }}">
            {{ 'COMMON_UI.FRAGEBOGEN.TAETIGKEITSART.LABEL' | translate }}
        </label>
        <div class="col-sm-8">
            <textarea
                    type="text"
                    id="taetigkeitsart{{index}}"
                    class="form-control"
                    formControlName="taetigkeitsart"
                    datevMessagePath="taetigkeitsart{{objectId}}"
                    rows="6"
                    data-eric-id="Betrieb[1]/GewerbeArt[1]"
                    utilsCheckValidity utilsControlState utilsMarkRequired utilsValidationMessage>
            </textarea>
        </div>
      <div class="col-sm-8">
        <input class="form-check-input" formControlName="vermoegendsverwaltend"
               id="vermoegendsverwaltend"
               type="checkbox"/>
        <label class="form-check-label"
               for="vermoegendsverwaltend">{{ 'COMMON_UI.FRAGEBOGEN.VERMOEGENSVERWALTEND.LABEL' | translate }}
        </label>
      </div>
    </div>
</form>

